import {createContext, useContext} from 'react'

/**
 * Whether the surrounding rail is **collapsed** to a mini, icons-only strip.
 * `Sidebar collapsed` (or a bare `SidebarCollapsedProvider`) sets it; `MenuItem`
 * renders icon-only + a label tooltip, and `CollapsibleMenuItem` swaps its inline
 * panel for a flyout popover. Inert by default (`false`) — items render exactly
 * as today unless an (experimental) collapse provider wraps them, so this adds no
 * public API to the approved `MenuItem`/`Sidebar` and no behaviour change when off.
 */
export const SidebarCollapsedContext = createContext<boolean>(false)

/** Provide the collapsed state to all descendant menu items. */
export const SidebarCollapsedProvider = SidebarCollapsedContext.Provider

/** Read whether the rail is collapsed (default `false`). */
export function useSidebarCollapsed(): boolean {
  return useContext(SidebarCollapsedContext)
}
